(function () {

  // -----------------------------
  // FIX PRODUCT LINKS (COLLECTION)
  // -----------------------------
  function fixProductLinks(root = document) {
    root.querySelectorAll('a.product-item').forEach(link => {
      let href = link.getAttribute('href');
      if (!href) return;

      let match = href.match(/_ss=.*variant%3D(\d+)/);

      if (!match) {
        match = href.match(/[?&]variant=(\d+)/);
      }

      if (!match) return;

      const variantId = match[1];
      const handleMatch = href.match(/\/products\/[^?]+/);
      if (!handleMatch) return;

      const cleanUrl = handleMatch[0] + '?variant=' + variantId;
      link.setAttribute('href', cleanUrl);
    });
  }

  // -----------------------------
  // INIT VARIANT ON PRODUCT PAGE
  // -----------------------------
  function initVariantFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    if (!variantId) return;

    const productJsonEl = document.querySelector('[data-product-json]');
    if (!productJsonEl) return;

    const product = JSON.parse(productJsonEl.textContent);
    const variant = product.variants.find(v => String(v.id) === variantId);
    if (!variant) return;

    const options = variant.options;
    const optionGroups = document.querySelectorAll('[data-option-position]');

    optionGroups.forEach((group, index) => {
      const value = options[index];
      if (!value) return;

      const input = group.querySelector(`input[value="${value}"]`);
      if (input) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const select = group.querySelector('select');
      if (select) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // -----------------------------
  // CART COUNT UPDATE (OPUS)
  // -----------------------------
  function initCartListener() {
    window.addEventListener('OpusCartChange', (event) => {
      const itemsCount = event.detail.item_count;

      const iconCount = document.querySelectorAll(
        '.navlink__cart__content.cart-count.header__cart__status'
      );

      iconCount.forEach((item) => {
        item.textContent = itemsCount > 0 ? itemsCount : '';
      });
    });
  }

  // -----------------------------
  // INIT
  // -----------------------------
  function init() {
    fixProductLinks();
    initVariantFromUrl();
    initCartListener();
  }

  // -----------------------------
  // MUTATION OBSERVER (OPTIMIZED)
  // -----------------------------
  let rafScheduled = false;

  const observer = new MutationObserver(() => {
    if (rafScheduled) return;

    rafScheduled = true;

    requestAnimationFrame(() => {
      fixProductLinks();
      rafScheduled = false;
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    init();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

})();

 // -----------------------------
  // CLEAN URL
  // -----------------------------
(function () {
  function cleanUrl() {
    try {
      const url = new URL(window.location.href);

      if (url.searchParams.has('hcUrl')) {
        url.searchParams.delete('hcUrl');

        const clean =
          url.pathname +
          (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') +
          url.hash;

        window.history.replaceState({}, '', clean);
      }
    } catch (e) {}
  }
  function cleanAllLinks(root = document) {
    root.querySelectorAll('a[href*="hcUrl"]').forEach(link => {
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.delete('hcUrl');

        link.href =
          url.pathname +
          (url.searchParams.toString() ? '?' + url.searchParams.toString() : '') +
          url.hash;
      } catch (e) {}
    });
  }

  function init() {
    cleanUrl();
    cleanAllLinks();
  }
  const originalPushState = history.pushState;
  history.pushState = function () {
    originalPushState.apply(this, arguments);
    cleanUrl();
    cleanAllLinks();
  };

  const originalReplaceState = history.replaceState;
  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    cleanUrl();
    cleanAllLinks();
  };

  window.addEventListener('popstate', () => {
    cleanUrl();
    cleanAllLinks();
  });
  let rafScheduled = false;

  const observer = new MutationObserver(() => {
    if (rafScheduled) return;

    rafScheduled = true;

    requestAnimationFrame(() => {
      cleanAllLinks();
      rafScheduled = false;
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    init();

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

})();